export default __webpack_public_path__ + "static/media/Biblioteca.685960e1.jpeg";